import { createElement } from 'react';
import { ProForm as OriginalForm } from '@ant-design/pro-components';
const ProForm = (props) => {
    return (createElement(OriginalForm, Object.assign({}, props)));
};
export default ProForm;
